var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTether({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#50af95",
    d: "M23.638 14.903c-1.602 6.428-8.114 10.34-14.543 8.738C2.668 22.038-1.244 15.527.359 9.098S8.473-1.244 14.9.36c6.43 1.603 10.342 8.115 8.74 14.544z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.518 13.36c-.084.007-.523.033-1.5.033-.779 0-1.33-.023-1.525-.033-3.005-.132-5.249-.655-5.249-1.281 0-.627 2.244-1.15 5.25-1.284v2.044c.196.014.759.048 1.537.048.933 0 1.4-.04 1.485-.047v-2.043c3 .133 5.238.656 5.238 1.281 0 .626-2.238 1.149-5.238 1.282zm0-2.775v-1.83h4.186V5.967H6.308v2.79h4.185v1.828c-3.402.157-5.96.83-5.96 1.638s2.558 1.48 5.96 1.638v5.861h3.025v-5.864c3.394-.156 5.948-.829 5.948-1.636s-2.552-1.48-5.948-1.637z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTether);
export default __webpack_public_path__ + "static/media/Tether.5b1b268c70a42c4516f29f016edfc1d7.svg";
export { ForwardRef as ReactComponent };